module.exports = __webpack_public_path__ + "static/media/card-img.b8be4794.svg";